import { combine } from 'effector';
import { accountTreeModel } from 'entities/account';
import { createPlayerRegistryModel } from 'entities/player';
import { cashdeskPageModel } from './cashdesk-page-model';

const $accountId = cashdeskPageModel.$cashdesk.map((cashdesk) => cashdesk?.account.id ?? null);

const $filterAccountIds = combine($accountId, accountTreeModel.$nodes, (accountId, nodes) => {
	if (accountId === null) return [];

	const accountIds = Object.values(nodes)
		.filter((node) => node.value.parents.split('.').includes(String(accountId)))
		.map((node) => node.id);

	return accountIds.length > 0 ? accountIds : [accountId];
});

const playerRegistryModel = createPlayerRegistryModel({
	$currencies: cashdeskPageModel.$cashdesk.map((cashdesk) => (cashdesk ? [cashdesk.currency] : [])),
	$cashdeskId: cashdeskPageModel.$cashdesk.map((cashdesk) => cashdesk?.id ?? null),
	$accountId,
	$allAccountIds: $filterAccountIds,
});

export const cashdeskPagePlayersModel = {
	playerRegistryModel,
};
